// src/TeamPage.js
import React from 'react';
import { useParams } from 'react-router-dom';

const TeamPage = () => {
  const { teamId } = useParams();

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h2>{teamId} Page</h2>
      <p>This is where the team-specific item request form will be implemented.</p>
    </div>
  );
};

export default TeamPage;